import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const NoRecordsFound = () => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ height: "40vh" }}
    >
      <div className="mb-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100"
          height="100"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-muted"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
          <path d="M9 10h0.01" />
          <path d="M13 10h0.01" />
          <path d="M9.5 14a4 4 0 0 1 5 0" />
        </svg>
      </div>
      <h3 className="text-muted">No Records Found</h3>
    </div>
  );
};

export default NoRecordsFound;
